import { PaymentLinkList as UIPaymentLinkList, type PaymentLinkListProps as UIPaymentLinkListProps } from '@jagad/ui'
import { useTranslation } from 'react-i18next'

export type PaymentLinkListProps = Omit<
    UIPaymentLinkListProps,
    'emptyText' | 'quotationLabel' | 'currencyText'
>

const PaymentLinkList = (props: PaymentLinkListProps) => {
    const { t } = useTranslation()
    return (
        <UIPaymentLinkList
            {...props}
            emptyText={t('components.paymentLinkList.emptyText')}
            quotationLabel={t('components.paymentLinkActivityListItem.quotationLabel')}
            currencyText={t('components.paymentLinkActivityListItem.currencyText')}
        />
    )
}

export default PaymentLinkList
